import React from 'react';
import { Stack, Typography } from '@mui/material';
import { formatDate } from '@/utils/constants';
import { ImportFileButton } from './ImportFileButton';
import { UserChip } from '../../shared/chips/UserChip';
import { UserImportStatusChip } from '../../users/import/UserImportStatusChip';
import { IMPORT_TYPES } from './importTypes';

/**
 * The import history's columns, sorted on the server (see the backend's imports/list):
 * started (sortable), file (sortable), type, who started it, status (sortable), progress,
 * and the created / skipped / failed counts.
 */
export const importColumns = [
	{
		field: 'createdAt',
		headerName: 'Started',
		width: 200,
		hideable: false,
		valueFormatter: (value) => formatDate(value, true),
	},
	{
		field: 'fileName',
		headerName: 'File',
		flex: 1,
		minWidth: 220,
		hideable: false,
		// The name, then a button that downloads the uploaded file
		renderCell: ({ value, row }) => (
			<Stack direction='row' spacing={0.5} alignItems='center' sx={{ minWidth: 0 }}>
				<ImportFileButton storagePath={row.storagePath} fileName={value} />
				<Typography variant='body2' noWrap>
					{value}
				</Typography>
			</Stack>
		),
	},
	{
		field: 'importType',
		headerName: 'Type',
		width: 110,
		valueFormatter: (value) => IMPORT_TYPES.find(({ id }) => id === value)?.name ?? value,
	},
	{
		field: 'createdBy',
		headerName: 'Started by',
		width: 200,
		sortable: false,
		renderCell: ({ value }) => <UserChip id={value} />,
	},
	{
		field: 'status',
		headerName: 'Status',
		width: 120,
		renderCell: ({ value }) => <UserImportStatusChip status={value} />,
	},
	{
		field: 'processed',
		headerName: 'Progress',
		width: 120,
		sortable: false,
		valueFormatter: (value, row) => `${value} / ${row.total}`,
	},
	{ field: 'createdCount', headerName: 'Created', width: 100, sortable: false },
	{ field: 'skippedCount', headerName: 'Skipped', width: 100, sortable: false },
	{ field: 'failedCount', headerName: 'Failed', width: 100, sortable: false },
];
